import React from 'react';
import Head from "./Head";
import Header from "./Header";

function Layout({children}) {
    return (
        <div>
            <Head />

            <Header />
            {children}
        </div>
    );
}

export default Layout;